import { useSelector } from "react-redux";
import CrimeVictimItem from "./CrimeVictimItem";

const CrimeVictimDetails = () => {
    const activeCase = useSelector(state => state.case.activeCase)

    return <>
        {activeCase && activeCase.crime_victim && <CrimeVictimItem itemData={activeCase.crime_victim} apiCase={'case_crime_victim'}/>}
    </>
}

export default CrimeVictimDetails